import { Box, IconButton, Stack, Tooltip, Typography } from "@mui/material";

interface ICommandButton {
  isDisabled: boolean;
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
  tooltip: string;
}

const CommandButton: React.FC<ICommandButton> = ({ isDisabled, label, icon, onClick, tooltip }) => {
  return (
    <Stack sx={{ display: "flex", alignItems: "center", justifyContent: "center" }} spacing={1}>
      <Tooltip title={isDisabled ? tooltip : ""}>
        <Box>
          <IconButton onClick={onClick} disabled={isDisabled} sx={{ padding: 0, width: 50, height: 50 }}>
            <Box
              width="100%"
              height="100%"
              sx={{
                background: (theme: ThemeType) =>
                  isDisabled ? theme.palette.disabled.main : theme.palette.primary.main,
                borderRadius: "50%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}>
              {icon}
            </Box>
          </IconButton>
        </Box>
      </Tooltip>
      <Box width="100%" sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Tooltip title={label}>
          <Typography
            noWrap
            sx={{
              color: (theme: ThemeType) => theme.palette.primary.contrastText,
              fontSize: "10px",
              textAlign: "center",
            }}>
            {label}
          </Typography>
        </Tooltip>
      </Box>
    </Stack>
  );
};

export default CommandButton;
